module.exports = __webpack_public_path__ + "static/img/toapp.445a96b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toapp.png
// module id = V5fm
// module chunks = 1